import React, { useState } from "react";

import {
	useHistory,
	Redirect
} from "react-router-dom";

import {
	useCore,
	apiRequest,
	isMobileDevice
} from "../Core";

import Modals from "../components/Modals";
import Loader from "../components/Loader";
import GoogleLoginButton from "../components/GoogleLoginButton";

import config from "../config";

const GOOGLE_ERROR_MESSAGE = 'Accesso Google non riuscito, riprova';

export default function UserLogin() {

	const { 
		enableNoSleep,
		setIsLoading,
		authUser, 
		setAuthUser, 
		setTeacher, 
		setCurrentError, 
		currentUserJoin 
	} = useCore();

	const [ activeSessions, setActiveSessions ] = useState( [] );
	const [ tempStudent, setTempStudent ] = useState( {} );
	const [ context, setContext ] = useState( 'student' );

	let history = useHistory();

	/* */

	// gestione della risposta di /login/ e /login/google/ (stessa forma): comune a login classico e Google
	function gestisciRispostaLogin( apiData, { username, displayName, context, isGoogle } ) {

		if ( apiData.result === "error" ) {

			if ( isGoogle ) setCurrentError( apiData.message || GOOGLE_ERROR_MESSAGE );
			else if ( apiData.code === 552 || apiData.code === 551 ) setCurrentError( apiData.message );
			else setCurrentError( 'I dati di accesso inseriti non risultano validi.' );

			setIsLoading( false );

		}
		else if ( isGoogle && !username ) {

			// risposta Google senza username: senza identita' non si puo' entrare in aula
			setCurrentError( GOOGLE_ERROR_MESSAGE );

			setIsLoading( false );

		}
		else {

			let user = { ...apiData };

			user.name = username;
			user.displayName = displayName;
			user.cloud_id = apiData.cloudData.response.user_id;
			user.school_id = apiData.cloudData.response.school_id;
			
			setIsLoading( false );

			if ( context === "teacher" ) {

				setTeacher( true );

				user.isTeacher = true;
				user.session_id = apiData.sessionData.session_id;
				user.created_at = apiData.sessionData.created_at;

				setAuthUser( user );

				currentUserJoin( user );

				history.push('/');

			}
			else {

				if ( apiData.sessionData.length ) {

					user.isTeacher = false;						

					setTempStudent( user );

					setActiveSessions( apiData.sessionData );

				}
				else {

					setCurrentError('ATTENZIONE! Non ci sono ancora sessioni disponibili, attendere e riprovare a collegarsi.');

				}

			}

		}

	}

	/* */

	async function sendLogin( e ) {

		e.preventDefault();

		const formData = new FormData( document.querySelector('#frmLogin') );

		const params = {
			usr: formData.get('usr'),
			pwd: formData.get('pwd'),
			context: formData.get('context')
		};

		try {

			setIsLoading( true );

			const endpoint = config.API_BASENAME + '/login/';
			const apiData = await apiRequest( endpoint, 'POST', false, params );

			console.log('apiData:', apiData);

			gestisciRispostaLogin( apiData, {
				username: params.usr,
				displayName: params.usr,
				context: params.context,
				isGoogle: false
			} );

		} catch (err) {

			console.log('Error:', err);

			setCurrentError('Error: ' + err);

			setIsLoading( false );

		}

	};

	/* */

	async function sendLoginGoogle( credential ) {

		// il pulsante Google e' un iframe: il click non passa dal tasto LOGIN, quindi NoSleep si attiva qui
		if ( isMobileDevice() ) enableNoSleep();

		try {

			setIsLoading( true );

			// fetch dedicato: apiRequest registra in console i parametri e il credential non deve finire nei log
			const endpoint = config.API_BASENAME + '/login/google/';
			const resp = await fetch( endpoint, {
				method: 'POST',
				headers: { "Content-Type": "application/json" },
				// senza context: con Google il ruolo lo riconosce il backend dal codice associato all'email
				body: JSON.stringify( { credential: credential } )
			} );

			const apiData = await resp.json();

			console.log('apiData:', apiData);

			// il ruolo (interfaccia e parsing di sessionData) arriva dalla risposta, non dalla schermata di partenza:
			// context restituito dal backend, altrimenti dalla forma di sessionData (array = studente)
			const role = ( apiData.context === 'teacher' || apiData.context === 'student' )
				? apiData.context
				: ( Array.isArray( apiData.sessionData ) ? 'student' : 'teacher' );

			gestisciRispostaLogin( apiData, {
				username: apiData.username,
				displayName: apiData.display_name || apiData.username,
				context: role,
				isGoogle: true
			} );

		} catch (err) {

			console.log('Error:', err);

			setCurrentError( GOOGLE_ERROR_MESSAGE );

			setIsLoading( false );

		}

	}

	/* */

	async function connectSession( e, sessionID ) {

		e.preventDefault();

		const params = {
			session_id: sessionID,
			studente_id: tempStudent.cloud_id,
			studente_name: tempStudent.name
		};

		try {

			setIsLoading( true );

			const endpoint = config.API_BASENAME + '/join/';
			const apiData = await apiRequest(endpoint, 'POST', tempStudent.tokenDjango, params);

			console.log('apiData:', apiData);

			setIsLoading( false );

			if ( apiData.result === "error" ) {

				setCurrentError('Errore durante la connessione alla sessione selezionata: ' + apiData.message );

				history.push('/');

			}
			else {

				console.log( 'tempStudent', tempStudent );

				let user = { ...tempStudent };

				user.session_id = sessionID;

				setAuthUser( user );

				// random delay (da 10ms a 50ms) per evitare maggiormente la possibilità di ingressi contemporanei
				const rand_delay = config.TIMEOUT_DELAY + Math.random() * ( 50 - config.TIMEOUT_DELAY );

				setTimeout(() => { 

					console.log( 'currentUserJoin randomly delayed...', rand_delay );

					currentUserJoin( user );

					history.push('/');

				}, rand_delay );

			}

		} catch (err) {

			console.log('Error:', err);

			setCurrentError('Error: ' + err);

			setIsLoading( false );

		}

	}

	return (

		authUser ?

			<Redirect to="/" />

			:
			<>
				<Loader/>

				<main className="main main-login d-flex justify-content-center vh-100">

					<div className="intro-container w-100">
						<div className="logo-container">
							<div className="logo">
								<a href={ config.SERVER_BASENAME }>
									<img src="assets/images/logo_opedialingue.png" alt="Opedia Lingue" />
								</a>
							</div>
							<div className="login-deco">
								<img src="assets/images/login_cloud.png" alt="Opedia Lingue" />
							</div>
						</div>
					</div>

					{
						activeSessions.length ?

							<div className="form-container align-self-center p-4">
								<div className="form-logo d-flex align-items-center justify-content-center">
									<div className="form-heading text-center">
										<div className="form-deco">
											<img src="assets/images/pencil.png" alt="Opedia Lingue" />
										</div>
										<div className="form-title">
											<span>Seleziona Docente:</span>
										</div>
									</div>
								</div>
								<div className="teacher-list d-flex flex-column px-4 py-3">

									{
										activeSessions.map((item) => {

											return (

												<div key={item.docente_id} className="card card-teacher py-4" style={{ cursor: "pointer" }}>
													<div className="card-teacher-item" onClick={(e) => connectSession(e, item.session_id)}>
														<i className="fas fa-user"></i>
														<span className="ml-3">
															{ item.docente_name }<br/>
															<small>Sessione: { item.session_id } - <small>{ item.created_at }</small></small>
														</span>
													</div>
												</div>

											)

										})
									}

								</div>
							</div>

							:

							<div className="form-container align-self-center p-4">
								<div className="form-logo d-flex align-items-center justify-content-center">
									<div className="form-heading text-center">
										<div className="form-deco">
											<img src="assets/images/cloud.png" alt="Opedia Lingue" />
										</div>
										<div className="form-title">
											<span>Accedi con</span> <img src="assets/images/logo_opedia_cloud.png" alt="Opedia Lingue" />											
										</div>
									</div>
								</div>
								<div className="form text-center">
									<form id="frmLogin" onSubmit={(e) => sendLogin(e)}>
										<div className="form-group">
											<label>Accedi come:</label>
											<select className="custom-select" name="context" value={ context } onChange={ (e) => setContext( e.target.value ) }>
												<option value="student">Studente</option>
												<option value="teacher">Docente</option>
											</select>
										</div>
										<div className="form-group">
											<label>Nome Utente:</label>
											<input name="usr" type="text" className="form-control" autocorrect="off" autocapitalize="off" required />
										</div>
										<div className="form-group">
											<label>Password:</label>
											<input name="pwd" type="password" className="form-control" autocorrect="off" autocapitalize="off" required />
										</div>
										<button type="submit" className="btn my-3" onClick={ () => isMobileDevice() ? enableNoSleep() : null }>LOGIN</button>
										<div className="d-flex align-items-center mb-3">
											<hr className="flex-grow-1 m-0" />
											<small className="mx-2 text-muted">oppure</small>
											<hr className="flex-grow-1 m-0" />
										</div>
										<small className="d-block text-muted mb-2">
											Utilizza il tuo account Google della scuola per accedere come Studente o Docente
										</small>
										<GoogleLoginButton
											clientId={ config.GOOGLE_CLIENT_ID }
											onCredential={ sendLoginGoogle }
											onError={ () => setCurrentError( GOOGLE_ERROR_MESSAGE ) }
										/>
										<br/><br/>
										<small>v { config.APP_VERSION }</small>
									</form>
								</div>
							</div>

					}

				</main>

				<Modals />
			</>
	);

}
